module.exports = __webpack_public_path__ + "img/night-top-bg_zh.a26b0965.png";